import React from "react";
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss';

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid white' }}
            date="Dec 2024 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Research Engineer II - Robotics</h3>
            <h4 className="vertical-timeline-element-subtitle">Orono, ME</h4>
            <p>
              Very Large Additive Manufacturing (VLAM) 3D Reconstruction.
            </p>
            <p><strong>Skills:</strong> Python, Computer Vision, Artificial Intelligence, Robot Programming</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jun 2024 - Dec 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Grad ML Researcher</h3>
            <h4 className="vertical-timeline-element-subtitle">Orono, ME</h4>
            <p>
              VLAM extrusion tracking using AI techniques.
            </p>
            <p><strong>Skills:</strong> Python, Computer Vision, Artificial Intelligence</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Aug 2022 - Jun 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Graduate Research Assistant @ CVAR Lab</h3>
            <h4 className="vertical-timeline-element-subtitle">Orono, ME</h4>
            <p>
              Experimented with pre-training deep learning models, conducted surveys on Cross-View Geo-Localization,
              and worked on attention-based models for CVGL.
            </p>
            <p><strong>Skills:</strong> Python, Deep Learning, Data Structures, Data Processing, Keras</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Aug 2022 - Jun 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Graduate Teaching Assistant</h3>
            <h4 className="vertical-timeline-element-subtitle">Orono, ME</h4>
            <p>
              Conducted recitation classes and assisted in grading and teaching courses such as Electric Circuits,
              Sequential Logic Systems, and Object-Oriented Programming with Python.
            </p>
            <p><strong>Skills:</strong> Communication, Grading, Problem Solving, University Teaching</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Sep 2021 - Aug 2022"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full Stack Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Hyderabad, India</h4>
            <p>
              Developed Angular components for Infor Supplier Exchange and low-code software for PySpark applications using React.
            </p>
            <p><strong>Skills:</strong> React.js, Spring Boot, JavaScript, HTML</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jul 2021 - Aug 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Semiconsoul Technologies, Hyderabad, India</h4>
            <p>
              Developed code to sort and store live data using Python.
            </p>
            <p><strong>Skills:</strong> Python, Data Structures</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Feb 2021 - Jun 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Hindustan Aeronautics Limited, Bengaluru, India</h4>
            <p>
              Developed an application to process Mil Bus 1553 data and created a visualization interface.
            </p>
            <p><strong>Skills:</strong> Python, Data Structures, Parallel Computing</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2019 - Jul 2019"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Assurance by NanoHealth, Hyderabad, India</h4>
            <p>
              Optimized database queries for efficiency.
            </p>
            <p><strong>Skills:</strong> MySQL</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2018 - Jul 2018"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">EAIESB Software Solutions, Hyderabad, India</h4>
            <p>
              Built dynamic chatbots using Python and Dialogflow.
            </p>
            <p><strong>Skills:</strong> Python, Dialogflow</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
